import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components';

const useTheme = () => {
    return useContext(ThemeContext);
    
}

export default useTheme;